import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormStateService {
  private formState = new BehaviorSubject<boolean>(false);
  currentFormState = this.formState.asObservable();

  updateFormState(isValid: boolean) {
    this.formState.next(isValid);
  }
}
